import React from 'react';
import { Label } from './ui/label';

export default function HomeroomSelect({ id, grades = [], value, onChange }) {
  return <div>
    <Label htmlFor={id}>Salón hogar asignado</Label>
    <select id={id} value={value || ''} disabled={!grades.length}
      onChange={e => onChange(e.target.value || null)}
      className="w-full border border-slate-300 rounded-md p-2 mt-1 bg-white text-sm">
      <option value="">Sin salón hogar asignado</option>
      {grades.map(grade => <option key={grade} value={grade}>{grade}</option>)}
    </select>
    <p className="text-xs text-slate-500 mt-1">Selecciona primero sus grados. El maestro de salón hogar aparecerá automáticamente en las boletas de ese grado.</p>
  </div>;
}
